export const DEFAULT_CURRENCY = 'THB';
